module.exports = __webpack_public_path__ + "static/media/step1.a2ae23e8.png";